import { render, staticRenderFns } from "./EditAprovalSOSPopup.vue?vue&type=template&id=1284a2c0&scoped=true"
import script from "./EditAprovalSOSPopup.vue?vue&type=script&lang=js"
export * from "./EditAprovalSOSPopup.vue?vue&type=script&lang=js"
import style0 from "./EditAprovalSOSPopup.vue?vue&type=style&index=0&id=1284a2c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1284a2c0",
  null
  
)

export default component.exports